// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ESrnD","buttons":"styles_buttons__3a8S9"};